import {endpointKeys} from '@common/api'
import {
  PartnerWorkingHour,
  UpsertPartnerWorkingHourRequest,
} from '@common/models'
import {
  partnerWorkingHourNormaliser,
  partnerWorkingHoursNormaliser,
} from '@common/normalisers'

import {useApi, useWebGet, useWebSet} from './helpers'

/**
 * Hooks for Partner Working Hours management
 * Base path: /api/v1/partner-administrators/partner-working-hours
 */

export const useGetPartnerWorkingHours = () =>
  useWebGet<PartnerWorkingHour[]>(
    [endpointKeys.partnerWorkingHours],
    useApi().partnerWorkingHours(),
    partnerWorkingHoursNormaliser,
  )

export const useCreatePartnerWorkingHour = () =>
  useWebSet<UpsertPartnerWorkingHourRequest, PartnerWorkingHour>(
    [endpointKeys.partnerWorkingHours],
    useApi().partnerWorkingHours(),
    'POST',
    partnerWorkingHourNormaliser,
    [
      [endpointKeys.partnerWorkingHours],
      // Partner working hours change can affect availability for all practitioners
      [endpointKeys.partnerAdminPractitionerAvailability],
    ],
  )

export const useUpdatePartnerWorkingHour = (id: string) =>
  useWebSet<UpsertPartnerWorkingHourRequest, PartnerWorkingHour>(
    [endpointKeys.partnerWorkingHour, {id}],
    useApi().partnerWorkingHour({id}),
    'PUT',
    partnerWorkingHourNormaliser,
    [
      [endpointKeys.partnerWorkingHours],
      [endpointKeys.partnerAdminPractitionerAvailability],
    ],
  )

export const useDeletePartnerWorkingHour = (id: string) =>
  useWebSet<void, void>(
    [endpointKeys.partnerWorkingHour, {id}],
    useApi().partnerWorkingHour({id}),
    'DELETE',
    (data) => data,
    [
      [endpointKeys.partnerWorkingHours],
      [endpointKeys.partnerAdminPractitionerAvailability],
    ],
  )
